// store/modules/promotions.js

import axios from 'axios';
import Vue from 'vue';
import moment from 'moment';

// Initial state
const state = {
  promotions: [],
  loading: false,
  error: null
};

// Getters
const getters = {
  getAllPromotions: state => state.promotions,
  getPublishedPromotions: state => state.promotions.filter(promo => promo.status === 'published'),
  getDraftPromotions: state => state.promotions.filter(promo => promo.status === 'draft'),
  getPromotionById: state => id => state.promotions.find(promo => promo.promoAwardID === id),
  isLoading: state => state.loading
};

// Actions
const actions = {
  // Update the fetchPromotions action to use POST method
  async fetchPromotions({ commit }) {
    commit('SET_LOADING', true);
    return axios.post(`${Vue.prototype.$API_URL}/api/Nustar/GetPromotionListForSystemADI`, {})
      .catch(error => {
        console.log(error);
      })
      .finally(() => {
        return axios.post(`${Vue.prototype.$API_URL}/api/Nustar/GetPromotionAwardsListSystem`, {
            "listPromotionAwardsID": ""
          })
          .then(response => {
            console.log(response.data, 'data adi');
            const { data } = response.data;
            commit('SET_PROMOTIONS', data);
            commit('SET_LOADING', false);
            return data;
          })
          .catch(error => {
            commit('SET_ERROR', error);
            commit('SET_LOADING', false);
            throw error;
          });
      });
  },

  // Create new promotion
  createPromotion({ commit }, promotion) {
    commit('SET_LOADING', true);

    // Simulate API call
    return new Promise((resolve) => {

      // setTimeout(() => {
      //   const newPromotion = {
      //     ...promotion,
      //     PromoAwardID: Math.max(...mockPromotions.map(p => p.PromoAwardID)) + 1
      //   };
      //   commit('ADD_PROMOTION', newPromotion);
      //   commit('SET_LOADING', false);
      //   resolve(newPromotion);
      // }, 500);
    });
  },

  // Update existing promotion
  updatePromotion({ commit }, promotion) {
    commit('SET_LOADING', true);

    return axios.post(`${Vue.prototype.$API_URL}/api/Nustar/UpdatePromotion`, promotion)
      .then(response => {
        commit('UPDATE_PROMOTION', promotion);
        commit('SET_LOADING', false);
        return promotion;
      })
      .catch(error => {
        commit('SET_ERROR', error);
        commit('SET_LOADING', false);
        throw error;
      });
  },

  // Delete promotions
  deletePromotions({ commit }, promotionIds) {
    commit('SET_LOADING', true);

    return new Promise((resolve) => {
      setTimeout(() => {
        commit('DELETE_PROMOTIONS', promotionIds);
        commit('SET_LOADING', false);
        resolve();
      }, 500);
    });
  },

  // Publish promotions
  publishPromotions({ commit }, promotionIds) {
    commit('SET_LOADING', true);

    return new Promise((resolve) => {
      setTimeout(() => {
        commit('UPDATE_PROMOTIONS_STATUS', { ids: promotionIds, status: 'published' });
        commit('SET_LOADING', false);
        resolve();
      }, 500);
    });
  },

  // Set promotions to pending approval
  setPendingApproval({ commit }, promotionIds) {
    commit('SET_LOADING', true);

    return new Promise((resolve) => {
      setTimeout(() => {
        commit('UPDATE_PROMOTIONS_STATUS', { ids: promotionIds, status: 'pending' });
        commit('SET_LOADING', false);
        resolve();
      }, 500);
    });
  }
};

// Mutations
const mutations = {
  SET_LOADING(state, isLoading) {
    state.loading = isLoading;
  },

  SET_PROMOTIONS(state, promotions) {
    state.promotions = promotions;
  },

  ADD_PROMOTION(state, promotion) {
    state.promotions.push(promotion);
  },

  UPDATE_PROMOTION(state, updatedPromotion) {
    const index = state.promotions.findIndex(promo => promo.promoAwardID === updatedPromotion.promoAwardID);
    if (index !== -1) {
      Vue.set(state.promotions, index, updatedPromotion);
    }
  },

  DELETE_PROMOTIONS(state, promotionIds) {
    state.promotions = state.promotions.filter(promo => !promotionIds.includes(promo.promoAwardID));
  },

  UPDATE_PROMOTIONS_STATUS(state, { ids, status }) {
    state.promotions.forEach(promo => {
      if (ids.includes(promo.promoAwardID)) {
        promo.status = status;
      }
    });
  },

  SET_ERROR(state, error) {
    state.error = error;
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/promotions.js